export default __webpack_public_path__ + "static/media/tabledown.c8430ed5.svg";